import { Modal } from 'components/Modal';
import styles from './ModalPayments.module.scss';
import { Button } from 'ui/Button';
import { useState } from 'react';
import { useReplayPaymentsByPlatformMutation } from 'redux/Api/ordersApi/ordersApi';
import { Loader } from '@mantine/core';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as Check } from './img/check.svg';

export const ModalPayments = ({
  isShowPaymentsModal,
  setIsShowPaymentsModal,
  orderId,
  handleSuccess,
}: {
  isShowPaymentsModal: boolean;
  setIsShowPaymentsModal: (e: boolean) => void;
  orderId: string;
  handleSuccess: (e: string) => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [textError, setTextError] = useState('');
  const [replayPaymentsByPlatform] = useReplayPaymentsByPlatformMutation();

  const handlereplayPaymentsOrder = async () => {
    setIsLoading(true);
    setTextError('');
    try {
      await replayPaymentsByPlatform({ orderId }).unwrap();

      setIsShowPaymentsModal(false);
      handleSuccess('Выплата успешно отправлена');
    } catch (error: unknown) {
      console.error('Error canceling order:', error);
      const errorMessage =
        (error as { data?: { message?: string } })?.data?.message ||
        'Произошла ошибка при отправке выплаты';
      setTextError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal setOpen={setIsShowPaymentsModal} open={isShowPaymentsModal}>
      <div className={styles.root}>
        <p className={styles.title}>Внимание!</p>

        <p className={styles.info}>Отправить повторно выплату исполнителю?</p>

        <div className={styles.btn_wrapper}>
          <Button
            onClick={() => setIsShowPaymentsModal(false)}
            theme='outline'
            className={styles.btn_cancel}
            size='L'>
            <IconCancel />
          </Button>
          <Button
            size='L'
            onClick={() => handlereplayPaymentsOrder()}
            className={styles.btn}
            theme='filed'>
            <div className={styles.textBtn}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Подтвердить
                <div style={{ width: '22px', height: '22px' }}>
                  {isLoading ? (
                    <Loader size='xs' color='white' />
                  ) : (
                    <Check style={{ width: '22px', height: '22px' }} />
                  )}
                </div>
              </div>
            </div>
          </Button>
        </div>
        {textError && <p className={styles.error}>{textError}</p>}
      </div>
    </Modal>
  );
};
